import { Directive, HostBinding, HostListener, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Projects } from '@usimweb/core/models';
import { ViewContainerRefService } from './viewContainerRefService';

@Directive({
    selector: '[cdkDetailRow]',
    standalone: false
})
export class CdkDetailRowDirective {
  private row: any;
  private tRef!: TemplateRef<any>;
  private opened!: boolean;
  private index!: number;
  private dataTableSource!: MatTableDataSource<Projects>;

  @HostBinding('class.expanded')
  get expended(): boolean {
    return this.opened;
  }

  @Input()
  set cdkDetailRow(value: any) {
    if (value !== this.row) {
      this.row = value;
    }
  }

  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
    console.log('click');
    if (value !== this.tRef) {
      this.tRef = value;
    }
  }

  @Input('cdkDetailRowColor')
  set cdkDetailRowColor(dataSource: MatTableDataSource<Projects>) {
    this.dataTableSource = dataSource;
  }

  @Input('cdkDetailRowIndex')
  set cdkDetailRowIndex(index: number) {
    this.index = index;
  }

  constructor(public vcRef: ViewContainerRef, private viewContainerRefService: ViewContainerRefService) {
    this.viewContainerRefService.setViewRef(vcRef);
  }

  closeAll() {
    this.viewContainerRefService.getViewRefs().forEach((vcRef) => {
      vcRef.clear();
    });
  }

  @HostListener('click')
  onClick(): void {
    this.toggleRowColor();
    this.closeAll();
    this.toggle();
  }

  // FIXME
  toggleRowColor() {
    // this.dataTableSource.data.forEach((element, index) => {
    //   if (this.index != index) {
    //     this.dataTableSource.data[index].expanded = false;
    //   } else {
    //     this.dataTableSource.data[index].expanded = true;
    //   }
    // });
  }

  toggle(): void {
    if (this.opened) {
      this.vcRef.clear();
    } else {
      this.render();
    }
    this.opened = this.vcRef.length > 0;
  }

  private render(): void {
    this.vcRef.clear();
    if (this.tRef && this.row) {
      this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
    }
  }
}
